;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";import * as Sentry from "@sentry/nextjs";
import { redactBreadcrumb, redactEvent } from "@utils/sentry";

const BUILD_ENV = process.env.BUILD_ENV;
const NODE_ENV = process.env.NODE_ENV;
const environment = NODE_ENV || BUILD_ENV || "local";

const SENTRY_ENV = process.env.SENTRY_ENV || environment;
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_RELEASE = process.env.GITHUB_SHA;

Sentry.init({
  attachStacktrace: true,
  debug: environment === "development" && !process.env.SENTRY_DISABLE_DEBUG,
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
  maxBreadcrumbs: 100,
  sampleRate: 1.0,
  tracesSampleRate: 1.0,
  beforeBreadcrumb: redactBreadcrumb,
  beforeSend: redactEvent,
  beforeSendTransaction: redactEvent,
});

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const onRouterTransitionStart = () => {};
